import { render, staticRenderFns } from "./ClCalcsResultCard.vue?vue&type=template&id=2a37eb8c&scoped=true&"
import script from "./ClCalcsResultCard.vue?vue&type=script&lang=js&"
export * from "./ClCalcsResultCard.vue?vue&type=script&lang=js&"
import style0 from "./ClCalcsResultCard.vue?vue&type=style&index=0&id=2a37eb8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a37eb8c",
  null
  
)

export default component.exports